<script setup lang="ts">
import { computed } from 'vue'
import MultiChoice from './questionTypes/MultiChoice.vue'
import SingleChoice from './questionTypes/SingleChoice.vue'
import TextField from './questionTypes/TextField.vue'
import NumberInput from './questionTypes/NumberInput.vue'
import SliderDisplay from './questionTypes/SliderDisplay.vue'

import type { SurveyQuestion } from '@/types/surveyTypes'
import { useSurvey, AnswerTarget } from '@/composables/onlineSurvey/useSurvey'

const { shouldShowQuestion } = useSurvey()

const props = defineProps<{
  question: SurveyQuestion
  answerTarget?: AnswerTarget // Optional prop with default
}>()

const showQuestion = computed(() => shouldShowQuestion(props.question))
</script>

<template>
  <div class="pb-4" v-if="showQuestion">
    <div class="my-5">
      <label :for="props.question.id" class="is-size-4">
        {{ props.question.label }}
        <span v-if="props.question.required" class="has-text-danger">*</span>
      </label>
    </div>
    <MultiChoice
      v-if="props.question.type === 'multi_choice'"
      :question="props.question"
      :answerTarget="props.answerTarget"
    />
    <SingleChoice
      v-else-if="props.question.type === 'single_choice'"
      :question="props.question"
      :answerTarget="props.answerTarget"
    />
    <TextField
      v-else-if="props.question.type === 'text'"
      :question="props.question"
      :answerTarget="props.answerTarget"
    />
    <NumberInput
      v-else-if="props.question.type === 'number'"
      :question="props.question"
      :answerTarget="props.answerTarget"
    />
    <SliderDisplay
      v-else-if="props.question.type === 'slider'"
      :question="props.question"
      :answerTarget="props.answerTarget"
    />
  </div>
</template>
